import { type FC } from "react"
import Typography from "@mui/material/Typography"

import type { TableStatColumn } from "types/dashboard.types"
import { valueFormatter } from "helpers/formatters/plots/plots"

interface ValueCellProps {
  column: TableStatColumn
  value?: number | string
  suffix: string
  decimalPlaces: number
  locale: string
}

const ValueCell: FC<ValueCellProps> = ({
  column,
  value,
  suffix,
  decimalPlaces,
  locale,
}) => {
  const formatted =
    typeof value === "number"
      ? valueFormatter({ value, suffix, decimalPlaces, locale, formatUnits: false })
      : "—"

  return (
    <Typography
      fontWeight="700"
      fontSize="0.8rem"
      noWrap
      textAlign={column.align ?? "left"}
    >
      {formatted}
    </Typography>
  )
}

export default ValueCell
